import React, { forwardRef, Ref, useState } from 'react';

import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { showToast } from '@/components/@base/toast/show-toast';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import XImage from '@/components/@base/x-image';
import Auth from '@/components/app/auth/components';
import AddCommentButton from '@/components/app/product/components/@shared/comments-header/add-comment-button';
import StarWithRateCount from '@/components/app/product/components/@shared/comments-header/star-with-rate-count';
import Props from '@/components/app/product/components/@shared/comments-header/type';
import AddComment from '@/components/app/product/components/comments/add-comment';
import RoundedIcon from '@/components/shared/components/icon/rounded';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import useCommonModalStore from '@/store/common-modal-store';

import { DATA_CY_ADD_COMMENT_BUTTON } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

function CommentsHeader(
  {
    rate,
    className,
    onAddCommentClick,
    data,
    isAuthenticated,
    isCommentsSummary = false,
  }: Props,
  ref?: Ref<HTMLDivElement>,
) {
  const [showModal, setShowModal] = useState(false);
  const { setShow } = useCommonModalStore();
  const handleAuthModal = () => {
    setShow(true, {
      DialogPanelProps: {
        className: 'rounded-xl overflow-hidden shadow-none! p-0! bg-transparent! ',
      },
      Body() {
        return <Auth />;
      },
    });
  };
  const clickHandler = () => {
    if (isCommentsSummary) {
      onAddCommentClick();
    } else {
      if (!isAuthenticated) {
        handleAuthModal();
      } else if (data.isProductBuyer) {
        if (data?.rated) {
          showToast({
            message: productLocalization.youHaveAlreadySubmittedAComment,
            type: 'error',
          });
        } else {
          setShowModal(true);
        }
      } else {
        onAddCommentClick();
      }
    }
  };
  return (
    <>
      <Container
        ref={ref}
        center
        className={cn('mb-4 justify-between md:mb-[30px]', className)}
      >
        <IconTextCombo
          id='comments'
          Icon={
            <RoundedIcon
              icon={
                <XImage
                  src={imagesList.icons.messageStar}
                  alt={productLocalization.comments}
                  width={20}
                  height={20}
                />
              }
            />
          }
          headingType={HEADING_TYPE.H2}
          title={productLocalization.comments}
          textClassName='text-base font-bold text-[#424B57]'
          wrapperClassName='max-w-max p-0'
        />

        <Container center className='gap-6'>
          {rate && (
            <StarWithRateCount
              value={parseFloat(rate.rateAverage.toFixed(1))}
              rateCount={rate.rateCount}
              textWrapperClassName='flex-col'
              textClassName='font-bold text-[#5B5C60] text-[18px]'
            />
          )}
          <AddCommentButton
            data-cy={DATA_CY_ADD_COMMENT_BUTTON}
            onAddCommentClick={clickHandler}
          />
        </Container>
      </Container>
      {showModal && <AddComment isShow={showModal} setShowModal={setShowModal} data={data} />}
    </>
  );
}

export default forwardRef(CommentsHeader);
